import { Component, Input } from '@angular/core';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from '@angular/material/expansion';
import { RouterLink } from '@angular/router';
import { OrderExists } from '../../pages/overview/models/order';

@Component({
  selector: 'app-purchase-order-list',
  standalone: true,
  templateUrl: './purchase-order-list.component.html',
  imports: [MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, RouterLink],
  styleUrl: './purchase-order-list.component.scss'
})
export class PurchaseOrderListComponent {
  @Input() orders?: OrderExists[] | null = null;
}
